/* prettier-ignore */

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { RestService } from './rest.service';
import { ModalController } from '@ionic/angular';
import { LoginComponent } from '../shared/login/login.component';
import Swal from "sweetalert2";
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})

export class UserService {
  private loginModal: any
  public eventsInscriptions: any = [];
  public favouritesPoints: any = [];
  public favouritesEvents: any = [];
  public favouritesRoutes: any = [];
  public eventsInscriptionsLoaded: boolean = false;
  public favouritesPointsLoaded: boolean = false;
  public favouritesEventsLoaded: boolean = false;
  public favouritesRoutesLoaded: boolean = false;

  public constructor(
    public http: HttpClient, 
    public authService: AuthService, 
    private rest: RestService, 
    public modalCtrl: ModalController, 
    public translate: TranslateService) 
  {}

// ----- EVENTOS ----------------------------------------------------------------------------------------------------------------------------------------------------------------
  getFavouritesEvents(){
    const userId = this.authService.userValue?.id;
    return this.http.get(`${this.rest.apiUrlBase}/api/get-events-wallet/${userId}`);
  }

  getEventsInscriptions(){
    const userId = this.authService.userValue?.id;
    return this.http.get(`${this.rest.apiUrlBase}/api/get-event-registers-user/${userId}`);
  }

  addFavouriteEvent(id): any{
    const userId = this.authService.userValue?.id;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const jsonData = { user_id: userId, events: [id] };
    return this.http.post(`${this.rest.apiUrlBase}/api/save-events-wallet`, jsonData, { headers: headers });
  }

  addEventInscription(id){
    const userId = this.authService.userValue?.id;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const jsonData = { user_id: userId, event_id: id };
    return this.http.post(`${this.rest.apiUrlBase}/api/confirm-register-event`, jsonData, { headers: headers });
  }

  removeFavouriteEvent(id): any{
    const userId = this.authService.userValue?.id;
    return this.http.get(`${this.rest.apiUrlBase}/api/delete-event-wallet/${id}/${userId}`);
  }

// ----- PUNTOS ----------------------------------------------------------------------------------------------------------------------------------------------------------------
  getFavouritePoints(){
    const userId = this.authService.userValue?.id;
    return this.http.get(`${this.rest.apiUrlBase}/api/get-interest-points-wallet/${userId}`);
  }

  addFavouritePoint(id): any{
    const userId = this.authService.userValue?.id;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const jsonData = { user_id: userId, interest_points: [id] };
    return this.http.post(`${this.rest.apiUrlBase}/api/save-interest-points-wallet`, jsonData, { headers: headers });
  }

  removeFavouritePoint(id): any{
    const userId = this.authService.userValue?.id;
    return this.http.get(`${this.rest.apiUrlBase}/api/delete-interest-point-wallet/${id}/${userId}`);
  }

// ----- RUTAS ----------------------------------------------------------------------------------------------------------------------------------------------------------------
  getFavouritesRoutes(){
    const userId = this.authService.userValue?.id;
    return this.http.get(`${this.rest.apiUrlBase}/api/get-routes-wallet/${userId}`);
  }

  addFavouriteRoute(id){
    const userId = this.authService.userValue?.id;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const jsonData = { user_id: userId, routes: [id] };
    return this.http.post(`${this.rest.apiUrlBase}/api/save-routes-wallet`, jsonData, { headers: headers });
  }

  removeFavouriteRoute(id){
    const userId = this.authService.userValue?.id;
    return this.http.get(`${this.rest.apiUrlBase}/api/delete-route-wallet/${id}/${userId}`);
  }

  getPersonalRoutesSaved(){
    //TODO: agregar cliente ID para filtrar rutas suyas
    const userId = this.authService.userValue?.id;
    return this.http.post(`${this.rest.apiUrlBase}/api/get-personal-routes-saved/${userId}`, {});
  }

// ----- USER INFO ----------------------------------------------------------------------------------------------------------------------------------------------------------------
  updateUserInfo(jsonData){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${this.rest.apiUrlBase}/api/update-personal-information`, jsonData, { headers: headers });
  }

  resetAll(){
    this.favouritesPoints = [];
    this.favouritesEvents = [];
    this.favouritesRoutes = [];
    this.eventsInscriptions = [];
  }


  checkUserFavouritesPoints() {
    if (this.authService.userValue?.id && !this.favouritesPointsLoaded) {
      this.getFavouritePoints().subscribe((res: any) => {
        if (res.interest_points){
          this.favouritesPoints = res.interest_points;
          this.favouritesPointsLoaded = true;
        }
      });
    }
  }

  checkUserFavouritesEvents() {
    if (this.authService.userValue?.id && !this.favouritesEventsLoaded) {
      this.getFavouritesEvents().subscribe((res: any) => {
        if (res.events){
          this.favouritesEvents = res.events;
          this.favouritesEventsLoaded = true;
        } 
      });
    }
  }

  checkUserFavouritesRoutes() {
    if (this.authService.userValue?.id && !this.favouritesRoutesLoaded) {
      this.getFavouritesRoutes().subscribe((res: any) => {
        if (res.routes){
          this.favouritesRoutes = res.routes;
          this.favouritesRoutesLoaded = true;
        } 
      });
    }
  }

  checkUserEventsInscriptions() {
    if (this.authService.userValue?.id && !this.eventsInscriptionsLoaded ) {
      this.getEventsInscriptions().subscribe((res: any) => {
        this.eventsInscriptions = res;
        this.eventsInscriptionsLoaded = true;
      });
    }
  }

  checkAllUserEntries(){
    this.checkUserFavouritesPoints();
    this.checkUserFavouritesEvents();
    this.checkUserFavouritesRoutes();
    this.checkUserEventsInscriptions();
  }

  async login() {
    this.loginModal?.dismiss();
    this.loginModal = await this.modalCtrl.create({
      component: LoginComponent,
      cssClass: "loginModal",
    });
    await this.loginModal.present();
  }

  showSwalFavourtives() {
    Swal.fire({
      title: "",
      text: this.translate.instant("Añadido a favoritos correctamente"),
      icon: "success",
      showCancelButton: false,
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  }

}